import React, { useState } from 'react'
import Modal from 'react-modal'
import ReactTable from 'react-table'

import { getModalStyles, groupBy } from '../../../common/utils'
import useSWR from '../../../hooks/useSWR'
import VendorsTable from './VendorsTable'

const VendorOnboardingModal = ({ lock, closeModal }) => {
  const [expandedCompany, setExpandedCompany] = useState(null)

  let { data: localDrivers } = useSWR('/subject/admin/drivers/local')
  const { data: checklist } = useSWR(`/subject/admin/locks/${lock._id}/carrier-checklist`)

  localDrivers = localDrivers && localDrivers.filter((d) => d.locks.includes(lock._id))

  const groupedChecklistByCompany = groupBy(checklist || [], (item) => item.company._id)

  const data = [...groupedChecklistByCompany.values()]

  return (
    <div>
      <Modal ariaHideApp={false} isOpen={true} onRequestClose={closeModal} style={getModalStyles()}>
        <div className="qCloseButton" onClick={closeModal}>
          Stäng
        </div>

        <br />
        <br />
        {checklist && !checklist.length ? (
          <div style={{ padding: 20, paddingLeft: 50 }}>Du har inga uppkopplade leverantörer för tillfället</div>
        ) : (
          <ReactTable
            data={data}
            columns={[
              {
                Header: <div style={{ textAlign: 'left', fontWeight: 'bold' }}>Mottagarföretag</div>,
                id: 'company',
                Cell: ({ original }) => <div>{original[0].company.name}</div>,
              },
              {
                Header: <div style={{ textAlign: 'left', fontWeight: 'bold' }}>Antal leverantörer</div>,
                id: 'vendors',
                width: 200,
                Cell: ({ original }) => {
                  const filteredItems = groupedChecklistByCompany.get(original[0].company._id).filter((item) => item.vendor)

                  return <div>{groupBy(filteredItems, (item) => item.vendor._id).size}</div>
                },
              },
            ]}
            getTdProps={(state, rowInfo) => ({
              onClick: () => {
                const { _id: companyId } = rowInfo.original[0].company
                setExpandedCompany(companyId === expandedCompany ? null : companyId)
              },
              style: { cursor: 'pointer' },
            })}
            expanded={{ ...data.map(([{ company }]) => company._id === expandedCompany) }}
            SubComponent={({ original }) => <VendorsTable items={groupedChecklistByCompany.get(original[0].company._id)} />}
            NoDataComponent={() => null}
            showPagination={false}
            showPageSizeOptions={false}
            loadingText="Laddar..."
            pageSize={data.length}
            className="-striped -highlight"
          />
        )}

        <hr />

        <div style={{ fontWeight: 'bold' }}>Vill du ha leveranser från ytterligare leverantörer? Be dem att kontakta Qlocx så hjälper vi dem att koppla på sig</div>

        {localDrivers && localDrivers.length > 0 && (
          <div>
            <h3>Lokala chaufförer</h3>
            {localDrivers.map((d) => (
              <div key={d._id}>{`${d.name} hos ${d.carrierName}`}</div>
            ))}
          </div>
        )}
      </Modal>
    </div>
  )
}

export default VendorOnboardingModal
